import React, { createContext, useContext, useState, useEffect } from "react";

interface DebugModeContextType {
  debugMode: boolean;
  toggleDebugMode: () => void;
}

const DebugModeContext = createContext<DebugModeContextType | undefined>(
  undefined
);

export function DebugModeProvider({ children }: { children: React.ReactNode }) {
  const [debugMode, setDebugMode] = useState<boolean>(() => {
    // Check for saved debug mode preference in localStorage
    const savedDebugMode = localStorage.getItem("debugMode");
    return savedDebugMode === "true";
  });

  // Update localStorage when debug mode changes
  useEffect(() => {
    localStorage.setItem("debugMode", debugMode.toString());
  }, [debugMode]);

  const toggleDebugMode = () => {
    setDebugMode((prev) => !prev);
  };

  return (
    <DebugModeContext.Provider value={{ debugMode, toggleDebugMode }}>
      {children}
    </DebugModeContext.Provider>
  );
}

export function useDebugMode() {
  const context = useContext(DebugModeContext);
  if (context === undefined) {
    throw new Error("useDebugMode must be used within a DebugModeProvider");
  }
  return context;
}
